import API from "../utils/apiCalling";

import {
    config,
} from "../utils/apiUrl";


/*
|--------------------------------------------------------------------------
| PLATFORM API
|--------------------------------------------------------------------------
|
| IMPORTANT:
|
| This API instance reads:
|
| localStorage.platformAccessToken
|
| NOT:
|
| localStorage.accessToken
|--------------------------------------------------------------------------
*/

const platformApi =
    new API({
        tokenKey:
            "platformAccessToken",
    });


/*
|--------------------------------------------------------------------------
| PLATFORM LOGIN
|--------------------------------------------------------------------------
|
| POST /v1/platform/auth/login
|
| No token required.
|--------------------------------------------------------------------------
*/

export const platformLoginService =
    async (
        payload
    ) => {

        return platformApi.post(

            config.platformLogin,

            payload,

            false

        );

    };


/*
|--------------------------------------------------------------------------
| PLATFORM PROFILE
|--------------------------------------------------------------------------
|
| GET /v1/platform/auth/me
|--------------------------------------------------------------------------
*/

export const getPlatformProfileService =
    async () => {

        return platformApi.get(

            config.getPlatformProfile

        );

    };